import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { Button } from "@truevault/aquilo";
import { useHistory } from "react-router-dom";
import { Routes } from "../../root/routes";

export function RetentionPolicyUpdateAlert({ hideUrgentHeading }: { hideUrgentHeading: boolean }) {
  const history = useHistory();
  return (
    <div className="tw-boundary">
      {!hideUrgentHeading && (
        <div className="text-[#4D260E] text-xl font-medium">
          Urgent items requiring your attention!
        </div>
      )}
      <div className="dashboard--urgent-alert dashboard--urgent-alert--warning">
        <div className="flex items-center gap-3 mb-3">
          <ExclamationTriangleIcon className="text-amber-700 w-[16px] h-[14px]" />
          <span className="text-amber-800 text-base font-medium">Data Retention</span>
        </div>
        <p className="text-neutral-900 font-bold text-lg mb-2">
          Your data retention policy needs an update
        </p>
        <p className="text-neutral-800 text-sm mb-4">
          Some retention purposes no longer have any data categories because that data was removed
          from your data map, so they’re missing from your privacy policy. For each one, select the
          data it covers, or, if it no longer applies, choose “Doesn’t apply to us” or remove it.
        </p>
        <Button color="primary" onClick={() => history.push(Routes.dataMap.dataRetention)}>
          Go to Data Retention
        </Button>
      </div>
    </div>
  );
}
